import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AsyncPaginate } from "react-select-async-paginate";
import { toast } from "react-toastify";
import { ceil } from "lodash";
import { getRegionsUser } from "store/thunks";
import { components } from "react-select";

interface Option {
  label: string | any;
  value: string;
}
interface DropdownOptionProps {
  name?: string;
  listChecked?: string | null;
  debounceTimeout?: number;
  onChangeSelect?: (params: Option) => void;
  isMulti?: boolean;
  placeholder?: string;
  isShowIconCheck?: boolean;
  hideSelectedOptions?: boolean;
  isAllOption?: boolean;
  paramsTypeUsers?: number;
  isDisabled?: boolean;
  isHideBatenderNull?: boolean;
  defaultParams?: any;
  isClearable?: boolean;
  isShowAvatar?: boolean;
  keyRegion: string;
}
const LIMIT = 30;

const DropdownAsyncRegions = ({
  name = "",
  listChecked,
  debounceTimeout = 700,
  onChangeSelect,
  isMulti = false,
  placeholder,
  hideSelectedOptions = true,
  isAllOption = false,
  paramsTypeUsers = 2,
  isDisabled = false,
  defaultParams = {},
  isClearable = true,
  keyRegion = '',
}: DropdownOptionProps) => {
  const { t } = useTranslation();
  // const [isAllCheckedUsers, setIsAllCheckedUsers] = useState(false);
  const [options, setOptions] = useState([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  const loadListUsers = async ({
    page,
    limit,
    search,
  }: {
    page: number;
    limit: number;
    search?: string;
  }) => {
    try {
      let params: any = {
        page,
        limit,
        ...defaultParams,
      };
  
      const {
        data: { list, meta },
        code,
      } = await getRegionsUser(params);
  
      if (!code) {
        return { success: false };
      }
  
      const dataUsersOptions = list?.map((a: any) => {
        return {
          value: a?.[keyRegion],
          label:  a?.[keyRegion],
          data: a,
        };
      });
  
      return {
        code,
        dataUsersOptions: dataUsersOptions || [],
        lastPage: ceil(meta?.total / meta?.limit),
      };
    }catch(err) {
      return {
        code: 404,
        dataUsersOptions: [],
        lastPage: 1,
      };
    }
  };

  async function loadOptions(
    search: string,
    loadedOptions: any[],
    { page }: { page: number }
  ) {
    const { code, dataUsersOptions, lastPage } = await loadListUsers({
      page,
      limit: LIMIT,
      search,
    });
    let dataUsersOptionsFormat = dataUsersOptions || [];

    if (code !== 200) {
      toast(`${t("Failed to load data")}`, CONFIG_OPTION_TOAST_ERROR);
      return {
        options: [],
        hasMore: false,
      };
    }

    let lastPageFormat = lastPage ? lastPage : 1;
    let options = isAllOption
      ? [
          ...(page === 1 ? [{ label: t("All Filter"), value: "all" }] : []),
          ...dataUsersOptionsFormat,
        ]
      : dataUsersOptionsFormat;

    setOptions(options);

    return {
      options: options,
      hasMore: lastPageFormat > page,
      additional: {
        page: page + 1,
      },
    };
  }

  let isAllCheckedUsers = false;
  const OptionFormat = (props: any) => {
    if (props?.isSelected && props?.value === "all") {
      isAllCheckedUsers = true;
    } else if (!props?.isSelected && props?.value === "all") {
      isAllCheckedUsers = false;
    }

    return (
      <components.Option {...props} style={{ zIndex: 999 }}>
        <div className="d-flex align-items-center gap-2">
          {(props?.isSelected || isAllCheckedUsers) ? (
            <i className="ri-check-line align-middle fs-14" />
          ) : (
            ""
          )}
          {props.data?.label}
        </div>
      </components.Option>
    );
  };

  return (
    <AsyncPaginate
      name={name}
      isMulti={isMulti}
      isClearable={isClearable}
      // defaultOptions
      options={options}
      debounceTimeout={debounceTimeout}
      value={listChecked}
      loadOptions={loadOptions}
      placeholder={placeholder}
      className="dropdown-status-rounded"
      hideSelectedOptions={false}
      onChange={(e: any) => setOnChangeOption(e)}
      additional={{
        page: 1,
      }}
      components={{
        Option: OptionFormat,
        // ...(isMulti ? { MenuList: MenuListAsync } : null),
        // MenuList: MenuListAsync,
      }}
      closeMenuOnSelect={hideSelectedOptions}
      menuPortalTarget={document.body}
      styles={{
        option: (styles: any) => {
          let styleNew = isMulti
            ? {
                ...styles,
                backgroundColor: "white",
                zIndex: 99,
                color: "black",
              }
            : styles;

          return styleNew;
        },
        control: (styles: any, { isFocused }: any) => {
          return {
            ...styles,
            borderColor: "#e9ebec",
            borderRadius: "0.6rem",
            color: "white",
            "&:hover": { borderColor: "#009ef7" },
          };
        },
        multiValue: (styles: any) => {
          return {
            ...styles,
            backgroundColor: "#009ef7",
          };
        },
        multiValueLabel: (styles: any) => ({
          ...styles,
          color: "white !important",
        }),
        menuPortal: (base: any) => ({
          ...base,
          zIndex: 1051,
        }),
      }}
      isDisabled={isDisabled}
    />
  );
};

export default DropdownAsyncRegions;
